import { animation, style, animate, trigger, transition, state, query, animateChild } from '@angular/animations';
var EnAnimations = /*#__PURE__*/function (EnAnimations) {
  EnAnimations["DEFAULT_TIMING"] = "300ms ease-in";
  EnAnimations["DEFAULT_STAGGER"] = "100ms ease-in";
  EnAnimations["DEFAULT_BEZIER"] = "0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)";
  return EnAnimations;
}(EnAnimations || {});
function queryOptions(opts = {}) {
  return Object.assign({
    optional: true
  }, opts);
}
const ANFade = animation([style({
  opacity: '{{ fromState }}'
}), animate('{{ timing }}', style({
  opacity: '{{ toState }}'
}))], {
  params: {
    timing: EnAnimations.DEFAULT_TIMING,
    fromState: '0',
    toState: '1'
  }
});
const ANShowFade = ({
  timingFrom = '200ms ease-in',
  timingTo = timingFrom,
  animationName = 'ANShowFade'
} = {}) => trigger(animationName, [transition(':enter', [style({
  opacity: 0
}), animate(timingFrom, style({
  opacity: 1
}))]), transition(':leave', [style({
  opacity: 1
}), animate(timingTo, style({
  opacity: 0
}))])]);
const ANStyles = ({
  fromStyle = {},
  toStyle = {},
  timingFrom = EnAnimations.DEFAULT_TIMING,
  timingTo = timingFrom,
  animationName = 'ANStyles',
  enableLeave = true
} = {}) => {
  const transitions = [transition(`:enter`, [style(fromStyle), animate(timingFrom, style(toStyle))])];
  if (enableLeave) {
    transitions.push(transition(`:leave`, [style(toStyle), animate(timingTo, style(fromStyle))]));
  }
  return trigger(animationName, transitions);
};
const ANStylesHide = ({
  fromStyle = {},
  toStyle = {},
  timing = EnAnimations.DEFAULT_TIMING,
  animationName = 'ANStylesHide'
} = {}) => trigger(animationName, [transition(':leave', [style(fromStyle), animate(timing, style(toStyle))])]);
const ANStylesState = ({
  fromStyle = {},
  fromState = '*',
  toStyle = {},
  toState = '*',
  timing = EnAnimations.DEFAULT_TIMING,
  animationName = 'ANStylesState'
} = {}) => {
  return trigger(animationName, [state(fromState, style(fromStyle)), state(toState, style(toStyle)), transition(`${fromState}<=>${toState}`, animate(timing))]);
};
const ANStylesQueryState = ({
  fromStyle = {},
  fromState = '*',
  toStyle = {},
  toState = '*',
  timing = EnAnimations.DEFAULT_TIMING,
  selectors = '@*',
  animationName = 'ANStylesState'
} = {}) => {
  return trigger(animationName, [transition(`${fromState}=>${toState}`, [query(selectors, [style(fromStyle), animate(timing, style(toStyle))], queryOptions())]), transition(`${toState}=>${fromState}`, [query(selectors, [style(toStyle), animate(timing, style(fromStyle))], queryOptions())])]);
};
const ANShowQuery = ({
  selectors = '@*',
  fromStyle = {},
  toStyle = {},
  timing = EnAnimations.DEFAULT_TIMING,
  animationName = 'ANShowQuery'
} = {}) => {
  return trigger(animationName, [transition(':enter', [query(selectors, [style(fromStyle), animate(timing, style(toStyle))], queryOptions())]), transition(':leave', [query(selectors, [style(toStyle), animate(timing, style(fromStyle))], queryOptions())])]);
};
const ANShowTriggerQuery = ({
  selectors = '@*',
  animationName = 'ANShowTriggerQuery'
} = {}) => {
  return trigger(animationName, [transition(':enter, :leave', [query(selectors, [animateChild()], queryOptions())])]);
};
const ANRepeatState = ({
  fromState = '*',
  toState = '*',
  fromStyle = {},
  toStyle = {},
  timing = EnAnimations.DEFAULT_TIMING,
  animationName = 'ANRepeatState'
} = {}) => trigger(animationName, [transition(`${fromState} <=> ${toState}`, [style(fromStyle), animate(timing, style(toStyle))])]);

/**
 * Generated bundle index. Do not edit.
 */

export { ANFade, ANRepeatState, ANShowFade, ANShowQuery, ANShowTriggerQuery, ANStyles, ANStylesHide, ANStylesQueryState, ANStylesState, EnAnimations, queryOptions };
